import React, {
	Component
} from 'react';

import styled from 'styled-components';

const LoaderBody = styled.div`
	display: none;
`

export class Loader extends Component {

	state = {
		loadCount: 0
	}

	loaded = () => {
		this.setState({loadCount: this.loadCount + 1});
	}

	render() {
		var children = [];
		if(this.props.children.length){
			for(let i = 0; i <= this.state.loadCount; i++){
				if(this.props.children[i]){
					let child = this.props.children[i];
					children.push(child);
				}
			};
			if(this.state.loadCount !== children.length){
				setTimeout(() => this.setState({loadCount: children.length}), 500);
			}
		} else {
			children = this.props.children;
		}
		return (
			<LoaderBody>
				{children}
			</LoaderBody>
		);
	}
}